<template>
  <div class="content">
    <p>商家审核列表</p>
    <div class="actions-bar">
      <el-input placeholder="请输入账号ID" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-select v-model="status" placeholder="请选择审核状态">
        <el-option label="全部" value=""></el-option>
        <el-option label="审核中" value="0"></el-option>
        <el-option label="审核通过" value="1"></el-option>
        <el-option label="审核不通过" value="2"></el-option>
        <el-option label="退出审核中" value="3"></el-option>
        <el-option label="已退出" value="4"></el-option>
      </el-select>

      <el-button type="primary" class="searchBtn" @click="handleSearch">搜索</el-button>
    </div>
    <el-table :data="MerchantList" style="width: 100%;height:920px;">
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column prop="nickName" label="nickName"> </el-table-column>
      <el-table-column prop="tel" label="电话"> </el-table-column>
      <el-table-column prop="email" label="email"> </el-table-column>
      <el-table-column prop="level" label="等级"> </el-table-column>
      <el-table-column prop="" label="冻结币种数">
        <template slot-scope="scope">
          <span>{{ scope.row.freezeAmount }}{{ scope.row.freezeCoin }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="住址"> </el-table-column>
      <el-table-column prop="emergencyName" label="紧急联系人"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">审核中</span>
          <span v-if="scope.row.status == 1">审核通过</span>
          <span v-if="scope.row.status == 2">审核不通过</span>
          <span v-if="scope.row.status == 3">退出审核中</span>
          <span v-if="scope.row.status == 4">退出</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row.id)" type="text" size="small">查看</el-button>
          <el-button
            type="text"
            @click="auditHandleClick(scope.row)"
            v-if="scope.row.status == 0 || scope.row.status == 3"
            size="small"
            >审核</el-button
          >
          <el-button @click="auditHandleClick(scope.row)" type="text" v-else disabled size="small">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next, total, jumper"
      @current-change="pageChange"
      @size-change="sizeChange"
      :current-page="page"
      :page-size="size"
      :total="MerchantListTotal"
      prev-text="上一页"
      next-text="下一页"
    >
    </el-pagination>
    <el-dialog title="商家详情" :visible.sync="merchantDetailVisible" width="40%" center>
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="applicationForm">
        <p class="fromCaptionTitle">商家信息</p>
        <el-form-item label="昵称" prop="nickName">
          <el-input v-model.trim="ruleForm.nickName" placeholder="中英字符或数字，16字符以内"></el-input>
        </el-form-item>
        <div class="fenGeXian"></div>

        <p class="fromCaptionTitle">基本信息</p>
        <el-form-item label="姓名" prop="name">
          <el-input v-model.trim="ruleForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model.trim="ruleForm.tel" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="电报" prop="wechat">
          <el-input v-model.trim="ruleForm.wechat" placeholder="请输入电报"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model.trim="ruleForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人" prop="emergencyName">
          <el-input v-model.trim="ruleForm.emergencyName" placeholder="请输入紧急联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="emergencyTel">
          <el-input v-model.trim="ruleForm.emergencyTel" placeholder="请输入紧急联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="与本人关系">
          <el-select v-model="ruleForm.relation" disabled placeholder="请选择与本人关系">
            <el-option label="父母" value="父母"></el-option>
            <el-option label="配偶" value="配偶"></el-option>
            <el-option label="子女" value="子女"></el-option>
            <el-option label="朋友" value="朋友"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="常住地址" prop="address">
          <el-input type="textarea" v-model="ruleForm.address"></el-input>
        </el-form-item>

        <div class="setImgBox">
          <div class="imgBox">
            <span class="fromCaptionTitle">身份证明</span>
            <img :src="ruleForm.authImage" alt="身份证照片" />
          </div>
          <div class="imgBox">
            <span class="fromCaptionTitle">户口本</span>
            <img :src="ruleForm.hkbImage" alt="户口本照片" />
          </div>
        </div>
        <div class="setImgBox">
          <div class="imgBox">
            <span class="fromCaptionTitle">地址证明</span>
            <img :src="ruleForm.addressImage" alt="地址证明" />
          </div>
          <div class="imgBox">
            <span class="fromCaptionTitle">视频证明</span>
            <video width="320" height="240" controls="controls">
              <source src="/i/movie.ogg" type="video/ogg" />
              <source :src="ruleForm.authVideo" type="video/mp4" />
            </video>
          </div>
        </div>

        <div class="fenGeXian"></div>
        <el-form-item label="商家等级" prop="name">
          <el-input v-model.trim="ruleForm.level" placeholder="商家等级"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="merchantDetailVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="merchantDetailVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="审核" :visible.sync="auditlVisible" width="40%" center>
      {{ auditForm }}
      审核ID:{{ auditForm.id }}
      <el-form :model="auditForm" status-icon ref="auditForm" label-width="100px" class="applicationForm">
        <p class="fromCaptionTitle">审核理由</p>
        <el-form-item label="理由" prop="nickName">
          <el-input type="textarea" v-model="auditForm.reason"></el-input>
        </el-form-item>
        <div class="fenGeXian"></div>

        <p class="fromCaptionTitle">审核状态</p>

        <el-form-item label="状态">
          <el-select v-model="auditForm.status" placeholder="请选择审核状态">
            <!-- <el-option label="审核中" value="0"></el-option> -->
            <el-option label="成为商户审核通过" value="1"></el-option>
            <el-option label="同意商户退出" value="4"></el-option>
            <el-option label="审核不通过" value="2"></el-option>
            <!-- <el-option label="退出审核中" value="3"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="auditlVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import api from "../../api";
export default {
  name: "merchantRecordList",
  data() {
    return {
      page: 1,
      size: 11,
      userId: "",
      status: '0',
      merchantDetailVisible: false,
      auditlVisible: false,
      ruleForm: {},
      auditForm: {
        id: "", //审核
        reason: "",
        status: ""
      }
    };
  },
  computed: {
    ...mapState("otc", ["MerchantListTotal","MerchantList", "MerchantDetail"])
  },
  components: {},
  methods: {
    ...mapActions("otc", ["getMerchantRecordList", "getMerchantDetail"]),

    pageChange(e) {
      this.page = e;
       this.handleSearch()
    },
    sizeChange(e) {
      console.log("siziChange--", e);
        this.page = e;
         this.handleSearch()
    },

    //shousuo
    handleSearch() {
      let that = this;
      if(that.userId) that.status=''
      this.getMerchantRecordList({
        userId: that.userId,
        status:that.status,
        size:that.size,
        page:that.page
      })
    },

    handleClick(id) {
      let that = this;
      this.merchantDetailVisible = true;
      api.getMerchantDetail(id).then(res => {
        console.log("商家详情", res);
        if (!res.code) {
          that.ruleForm = res.data;
        }
      });
    },

    //审核

    auditHandleClick(row) {
      console.log("当前详情：", row);
      let that = this;
      this.auditlVisible = true;
      this.auditForm.id = row.id;
    },

    auditBtn() {
      let that = this;
      // let data = JSON.stringify(this.auditForm);
      let data = this.auditForm;
      if (data.status === '2' && !data.reason) {
        const h = that.$createElement;
        that.$notify({
          title: "",
          message: h("i", { style: "color: red" }, "请填写拒绝的理由")
        });
        return false;
      }

      if (this.auditForm.status === '4') {
        api.quitMerchant(this.auditForm).then(() => {this.$message.success("操作成功")})
      }else {
        api.auditMerchant(data).then(res => {
          if (!res.code) {
            that.$message({
              message: res.msg,
              type: "success"
            });
            that.auditlVisible = false;
            that.handleSearch();
          } else {
            that.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      }
    }
  },

  mounted() {
    this.handleSearch();
  }
};
</script>

<style lang="less" scoped>
.content {
  .fenGeXian {
    width: 98%;
    height: 1px;
    background: #eaf0f2;
    clear: both;
    overflow: hidden;
    margin: 10px auto;
  }

  .actions-bar {
    width: 80%;
    display: flex;
    margin-bottom: 30px;
    .el-input{
      margin-right: 30px;
      width: 300px;
    }
    .searchBtn {
      margin-left: 15px;
    }
  }

  .setImgBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .imgBox {
      width: 46%;
      height: auto;
      border: 1px dashed #c8cdd1;
      padding: 12px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      span {
        font-size: 14px;
        font-weight: bold;
      }
      img {
        width: 80%;
        float: right;
      }
    }
  }
}
</style>
